import { useRef, useState } from 'react'

import type { ProductDataVariant } from '../../../../services/product/product-data'

type QuantitiesSelectedType = Record<string, number>

interface UseAddToCartParams {
  errorMessageDefault: string | undefined
}

export const useAddToCart = ({ errorMessageDefault }: UseAddToCartParams) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const [variantAssetsByAddToCart, setVariantAssetsByAddToCart] = useState<
    ProductDataVariant['assets']
  >([])
  const [variantCodeByAddToCart, setVariantCodeByAddToCart] = useState('')
  const [quantitiesSelected, setQuantitiesSelected] =
    useState<QuantitiesSelectedType>({})
  const [multibuySelections, setMultibuySelections] =
    useState<QuantitiesSelectedType>({})
  const [activeVariantByCard, setActiveVariantByCard] = useState<
    Record<string, string>
  >({})
  const autoDeliveryActionLock = useRef(false)

  const [errorMessageContent, setErrorMessageContent] = useState({
    message: null,
    title: errorMessageDefault,
    actions: null
  })

  return {
    isButtonDisabled,
    setIsButtonDisabled,
    variantAssetsByAddToCart,
    setVariantAssetsByAddToCart,
    variantCodeByAddToCart,
    setVariantCodeByAddToCart,
    quantitiesSelected,
    setQuantitiesSelected,
    multibuySelections,
    setMultibuySelections,
    activeVariantByCard,
    setActiveVariantByCard,
    errorMessageContent,
    setErrorMessageContent,
    autoDeliveryActionLock
  }
}
